import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import placeholder from '../../assets/front_page_form_img.png'
import Typography from '../Typography'
import Button from '../Button'
import Image from '../Image'
import { currencyFormatter, getOptionName } from '../../utils/functions'
import classes from './appointment-option.module.sass'

const AppointmentOption = ({
  option, handleSelect, i, onLoad,
}) => {
  const containerClasses = cn({
    [classes.appointmentOption]: true,
    [classes.primary]: i === 0,
    [classes.hidden]: option.prices.length === 0,
  })

  const headlineClasses = cn({
    [classes.headline]: true,
  })

  const optionName = getOptionName(option.name)

  return (
    <div className={containerClasses}>
      <Image
        alt="Package Image"
        onLoad={onLoad}
        src={option.imageUrl.includes('missing.png') ? placeholder : option.imageUrl}
      />
      <div className={classes.rightSide}>
        <div>
          <div className={headlineClasses}>
            {optionName[0].toLowerCase() === 'super' && (
              <p className={classes.shoutout}>SENIOR FAVORITE!</p>
            )}
            {optionName[0].toLowerCase() === 'deluxe' && (
              <p className={classes.shoutout}>BEST VALUE!</p>
            )}
            <Typography classes={classes.optionName} tag="span">
              <Typography tag="span">{optionName[0]}</Typography>
              {' '}
              {optionName[1]}
            </Typography>
          </div>
          {option.imageTypes.length > 0 && (
            <ul className={classes.imageTypeList}>
              {option.poses > 0 && <li style={{ fontWeight: 'bold' }}>{`${option.poses} poses`}</li>}
              {option.imageTypes.map((imageType) => <li key={imageType.id}>{imageType.name}</li>)}
              <Typography tag="span" classes={classes.price}>
                {option.prices.length > 0 ? currencyFormatter(option.prices[0].price) : '$0.00'}
              </Typography>
            </ul>
          )}
        </div>
        <Button classes={classes.btn} fullWidth variant="primary" size="small" onClick={() => handleSelect(option)}>Select</Button>
      </div>
    </div>
  )
}

AppointmentOption.defaultProps = {
  onLoad: () => { },
}

AppointmentOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    abbreviation: PropTypes.string.isRequired,
    additionalPoseCharge: PropTypes.number.isRequired,
    appointmentValue: PropTypes.number.isRequired,
    bestValue: PropTypes.bool.isRequired,
    createdAt: PropTypes.string.isRequired,
    displayType: PropTypes.string.isRequired,
    download: PropTypes.bool.isRequired,
    emailPicture: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    poses: PropTypes.number.isRequired,
    slug: PropTypes.string,
    superValue: PropTypes.bool.isRequired,
    updatedAt: PropTypes.string.isRequired,
    without: PropTypes.bool.isRequired,
    imageUrl: PropTypes.string,
    prices: PropTypes.array.isRequired,
    imageTypes: PropTypes.array.isRequired,
  }).isRequired,
  handleSelect: PropTypes.func.isRequired,
  i: PropTypes.number.isRequired,
  onLoad: PropTypes.func,
}

export default AppointmentOption
